"use strict";

const CUSTOM_WIDTH = {
  /**
   * - was 940 before AmpliFi was added to the navigation
   * - was 1038 before the UI.com redesign (change nav item copy and added icon)
   * - was 1095 before Greek was added as a language option
   */
  TOP_NAV_MOBILE: 1104,
  /**
   * Value that is bigger then `TOP_NAV_MOBILE` to show a more compact spacing on header to
   */
  TOP_NAV_DESKTOP_COMPACT: 1140
};
const CONTAINER_WIDTH = {
  MOBILE: 460,
  TABLET: 768,
  ACCOUNTS_CUSTOM: 832,
  // custom width for accounts screen
  DESKTOP: 1196,
  PRODUCT_PAGE: 980
};
const CONTAINER_PADDING = {
  MOBILE: 16,
  TABLET: 32,
  DESKTOP: 32
};
const BREAKPOINTS = {
  /**
   * Used only to target pretty-old or tiny mobile phones
   *
   * ! 9/10 times you should be using `BREAKPOINTS.MOBILE_AND_DOWN` instead !
   */
  SMALL_MOBILE_AND_DOWN: `(max-width: 376px)`,
  MOBILE_AND_DOWN: `(max-width: ${CONTAINER_WIDTH.MOBILE + CONTAINER_PADDING.MOBILE * 2}px)`,
  MOBILE_UP: `(min-width: ${CONTAINER_WIDTH.MOBILE + 1 + CONTAINER_PADDING.MOBILE * 2}px)`,
  TABLET_AND_DOWN: `(max-width: ${CONTAINER_WIDTH.TABLET + CONTAINER_PADDING.TABLET * 2}px)`,
  TABLET_UP: `(min-width: ${CONTAINER_WIDTH.TABLET + 1 + CONTAINER_PADDING.TABLET * 2}px)`,
  DESKTOP_AND_DOWN: `(max-width: ${CONTAINER_WIDTH.DESKTOP + CONTAINER_PADDING.DESKTOP * 2}px)`,
  TOP_NAV_MOBILE_AND_DOWN: `(max-width: ${CUSTOM_WIDTH.TOP_NAV_MOBILE}px)`,
  TOP_NAV_MOBILE_UP: `(min-width: ${CUSTOM_WIDTH.TOP_NAV_MOBILE + 1}px)`,
  /** Custom width for upsell tablet/medium */
  UPSELL_TABLET_AND_DOWN: `(max-width: 834px)`,
  CUSTOM_CHECKOUT_MOBILE_AND_DOWN: `(max-width: 850px)`
};
const PRODUCT_CARD = {
  DESKTOP: {
    WIDTH: 278,
    HEIGHT: 483
  },
  MOBILE: {
    WIDTH: 171,
    HEIGHT: 336
  }
};
const CHECKOUT_SUMMARY = {
  DESKTOP: {
    WIDTH: 408
  }
};
export { BREAKPOINTS, CHECKOUT_SUMMARY, CONTAINER_PADDING, CONTAINER_WIDTH, CUSTOM_WIDTH, PRODUCT_CARD };
//# sourceMappingURL=layout.mjs.map
